import { render, staticRenderFns } from "./VendorFilter.vue?vue&type=template&id=66c84b26&"
import script from "./VendorFilter.vue?vue&type=script&lang=js&"
export * from "./VendorFilter.vue?vue&type=script&lang=js&"
import style0 from "./VendorFilter.vue?vue&type=style&index=0&id=66c84b26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports